import React, { useEffect } from 'react';

export default function RasterWidget({
  layer,
  map,
  selectedSatelliteLayer,
  setSelectedSatelliteLayer
}) {
  const onChange = () => {
    setSelectedSatelliteLayer(prev =>
      prev?.id === layer.id ? null : layer
    );
  };

  useEffect(() => {
    if (!map.current) return;

    const style = map.current.getStyle();
    style.layers
      .filter(l => l.id.endsWith('-layer'))
      .forEach(l => {
        if (map.current.getLayer(l.id)) {
          map.current.removeLayer(l.id);
        }
      });
    Object.keys(style.sources)
      .filter(srcId => srcId.endsWith('-source'))
      .forEach(srcId => {
        if (map.current.getSource(srcId)) {
          map.current.removeSource(srcId);
        }
      });

    if (selectedSatelliteLayer) {
      const srcId = `${selectedSatelliteLayer.id}-source`;
      const lyrId = `${selectedSatelliteLayer.id}-layer`;

      map.current.addSource(srcId, {
        type: 'raster',
        url: selectedSatelliteLayer.url,
        tileSize: 256
      });

      map.current.addLayer({
        id: lyrId,
        type: 'raster',
        source: srcId
      });
    }
  }, [selectedSatelliteLayer, map]);

  const prettifyTilesetName = (input) => {
    return input
      .split('_')
      .map(part =>
        part
          .split(/([-–])/g)
          .map(chunk => {
            if (chunk === '-' || chunk === '–') return chunk;
            if (chunk.toLowerCase() === 'wfpi') return 'WFPI';
            return chunk.charAt(0).toUpperCase() + chunk.slice(1).toLowerCase();
          })
          .join('')
      )
      .join(' ');
  };

  return (
    <div className='weather-widgets-feature-layer-widget-expandable-expanded-row'>
      <input
        className='weather-widgets-feature-layer-widget-expandable-expanded-row-check'
        type='checkbox'
        checked={selectedSatelliteLayer?.id === layer.id}
        onChange={onChange}
      />
      <div className='weather-widgets-feature-layer-widget-expandable-expanded-row-name'>
        {prettifyTilesetName(layer.name)}
      </div>
    </div>
  );
}
